import React, { PureComponent } from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
  Divider,
  Button,
  Grid,
  Typography,
} from '@material-ui/core'

import { isValidString } from '../../utils/string'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'
import _ from 'lodash'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

class AddChecklistModal extends PureComponent {
  state = {
    name: '',
    categoryId: '',
    taskDetails: [],
  }

  addChecklist = () => {
    const { name, categoryId, taskDetails } = this.state

    if (!isValidString(name)) {
      this.props.onError('Please provide a valid checklist name')
      return
    }
    if (!isValidString(categoryId)) {
      this.props.onError('Please provide a valid checklist category')
      return
    }
    // if (taskDetails.length === 0) {
    //   this.props.onError("Please provide a checklist taskDetails");
    //   return;
    // }

    this.props.addChecklist({ name, categoryId, taskDetails })
  }

  onClose = () => {
    this.setState({
      name: '',
      categoryId: '',
      taskDetails: [],
    })
  }

  onOpen = (type) => {
    this.setState({
      name: '',
      categoryId: '',
      taskDetails: [],
    })
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  onChangeTask = (e, index) => {
    var tasks = [...this.state.taskDetails]
    tasks[index][e.target.name] = e.target.value
    this.setState({
      taskDetails: tasks,
    })
  }

  render() {
    const { forwardedRef, categoryList } = this.props

    const { name, categoryId, taskDetails } = this.state

    const addTask = () => {
      var taskAdded = [...taskDetails]
      taskAdded.push({
        position: taskAdded.length + 1,
        name: '',
      })
      this.setState({
        taskDetails: taskAdded,
      })
    }

    const removeTask = (event, index) => {
      var taskRemoved = [...taskDetails]
      taskRemoved.splice(index, 1)
      taskRemoved.map((task, i) => {
        task.position = task.position >= index + 1 ? task.position - 1 : task.position
      })
      this.setState({
        taskDetails: taskRemoved,
      })
    }

    return (
      <ModalDialog
        title={'Add Checklist'}
        size={'lg'}
        ref={forwardedRef}
        onConfirm={this.addChecklist}
        onClose={this.onClose}
        onOpen={this.onOpen}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Name *</InputLabel>
          <Input
            name="name"
            value={name}
            onChange={this.onChange}
            fullWidth
            inputProps={{
              maxLength: 50,
            }}
          />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Category *</InputLabel>
          <Select
            value={categoryId}
            name="categoryId"
            onChange={this.onChange}
            MenuProps={MenuProps}
          >
            {categoryList &&
              categoryList.map((category, i) => (
                <MenuItem key={i} value={category.id}>
                  {category.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <Grid style={{ margin: '10px 0px' }}>
          <Typography variant="subheading" style={{ float: 'right' }}>
            <Button size="small" className="primary-button" onClick={addTask}>
              {' '}
              Add Task{' '}
            </Button>
          </Typography>
          <Typography variant="title" style={{ paddingTop: '10px' }}>
            Task Details
          </Typography>
          <Divider style={{ display: 'block' }} />
        </Grid>
        <Grid container>
          {taskDetails &&
            taskDetails.map((task, index) => {
              return (
                <React.Fragment key={index}>
                  <Grid item sm={2}>
                    <FormControl fullWidth className="margin-bottom-small">
                      <InputLabel>Position</InputLabel>
                      <Input
                        name="position"
                        disabled
                        value={task.position}
                        fullWidth
                        inputProps={{
                          maxLength: 50,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item sm={8}>
                    <FormControl fullWidth className="margin-bottom-small">
                      <InputLabel>Name *</InputLabel>
                      <Input
                        name="name"
                        value={task.name}
                        onChange={(event) => this.onChangeTask(event, index)}
                        fullWidth
                        inputProps={{
                          maxLength: 50,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item sm={2} style={{ textAlign: 'right' }}>
                    <Button
                      style={{ marginTop: '16px' }}
                      size="small"
                      className="danger-button"
                      onClick={(event) => removeTask(event, index)}
                    >
                      {' '}
                      Remove{' '}
                    </Button>
                  </Grid>
                </React.Fragment>
              )
            })}
          {/* {
              taskDetails.length == 0
            } */}
        </Grid>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(AddChecklistModal)



// WEBPACK FOOTER //
// ./src/components/Modal/AddChecklistModal.js